import React, { useState } from 'react';

import { Text } from '@betterment/samba-react';
import { Button } from '@betterment/style-closet-react';

import { trackClick } from '../../features/track';
import { CHECKING_SUPPORT_PHONE } from '../../Shared/constants';

const ContactUs: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [isContactPhoneVisible, setContactPhoneVisible] = useState(false);

  return (
    <Text
      as="p"
      color="text.weak"
      css={{
        margin: 'space.0',
        fontSize: 'fontSize.50',
      }}
    >
      Issues with your card?{' '}
      {isContactPhoneVisible ? (
        <span>
          Call <a href={`tel:${CHECKING_SUPPORT_PHONE}`}>{CHECKING_SUPPORT_PHONE}</a>.
        </span>
      ) : (
        <Button
          variant="tertiary"
          onClick={() => {
            trackClick({ name: 'ContactUs', module: 'ManageCheckingAccount' });
            setContactPhoneVisible(true);
          }}
          m="0"
          pl="0"
          pt="0"
          fontSize="1"
          fontWeight="normal"
        >
          Contact support.
        </Button>
      )}
    </Text>
  );
};

export default ContactUs;
